<!--
 * @Author: Damon
 * @Date: 2020-09-21 10:58:33
 * @LastEditors: Damon
 * @LastEditTime: 2021-02-01 20:26:34
 * @Description: file content
-->
<template>
	<div :class="{'has-logo':showLogo}">
		<el-scrollbar wrap-class="scrollbar-wrapper">
			<el-menu :default-active="activeMenu" :collapse="isCollapse" :background-color="backgroundColor" text-color="#bfcbd9" :unique-opened="true" :active-text-color="activeTextColor" :collapse-transition="false" mode="vertical">
				<sidebar-item v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path" />
			</el-menu>
		</el-scrollbar>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import SidebarItem from './SidebarItem';
// import store from '@/store';

export default {
	components: { SidebarItem },

	computed: {
		...mapGetters(['permission_routes', 'sidebar']),
		activeMenu() {
			const route = this.$route;
			const { meta, path } = route;
			// if set path, the sidebar will highlight the path you set
			if (meta.activeMenu) {
				return meta.activeMenu;
			}
			return path;
		},
		showLogo() {
			return this.$store.state.settings.sidebarLogo;
		},
		// variables() {
		//   return variables
		// },
		isCollapse() {
			return false;
			// return !this.sidebar.opened;
		},
		backgroundColor() {
			if (process.env.NODE_ENV === 'production') {
				return '#304156';
			}
			// 浅色
			return '#353244';
			// return '#251f3d';  //深色
		},
		activeTextColor() {
			if (process.env.NODE_ENV === 'production') {
				return '#409EFF';
			}
			return '#409EFF';
		},
	},
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Index.vue